import bubbles from "../assets/bubbles.png";
import reacticon from "../assets/reacticon.png";
import profilslika from "../assets/profilslika.png";
import html from "../assets/html.png";
import css from "../assets/css.png";
import js from "../assets/js.png";
import react from "../assets/react.png";
import reactnative from "../assets/reactnative.png";
import github1 from "../assets/github1.png";
import sass from "../assets/sass.png";
import tailwind from "../assets/tailwind.png";
import linkedin from "../assets/linkedin.png";
import github from "../assets/github.png";
import project1 from "../assets/project1.png";
import project2 from "../assets/project2.png";
import project3 from "../assets/project3.png";
import project4 from "../assets/project4.png";

export default {
  bubbles,
  reacticon,
  profilslika,
  html,
  css,
  js,
  react,
  reactnative,
  github1,
  sass,
  tailwind,
  linkedin,
  github,
  project1,
  project2,
  project3,
  project4,
};
